import type { ComponentProps, PropsWithChildren } from 'react';
import { cn } from '~/utils/cn';

export function LandingSection({
  className,
  ...restProps
}: PropsWithChildren<ComponentProps<'div'>>) {
  return <div className={cn('py-8 lg:py-16', className)} {...restProps} />;
}
